import{halfPI as t}from"../../constants.min.mjs";const r=r=>{if(0===r)return 0;const n=r/t,s=Math.sign(r);switch(n){case 1:return s;case 2:return 0;case 3:return-s}return Math.sin(r)};export{r as sin};
//# sourceMappingURL=sin.min.mjs.map
